
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'flag-de': {
    width: 640,
    height: 480,
    viewBox: '0 0 640 480',
    data: '<path pid="0" _fill="#ffce00" d="M0 320h640v160H0z"/><path pid="1" _fill="#020202" d="M0 0h640v160H0z"/><path pid="2" _fill="#d00" d="M0 160h640v160H0z"/>'
  }
})
